import API_ENDPOINTS_CONSTANTS from "./endpoints";

function getPathKey(path = '') {
    if (!path) return path;
    // these are requests with qs. dont want to log
    if (path.includes(API_ENDPOINTS_CONSTANTS.endpoints.addressDetails)) {
        return API_ENDPOINTS_CONSTANTS.endpoints.addressDetails;
    } else if (path.includes(API_ENDPOINTS_CONSTANTS.endpoints.updateCartData)) {
        return API_ENDPOINTS_CONSTANTS.endpoints.updateCartData;
    }
    return path;
}

const logCache = {};
export function logResponseError(error, path, retryCount) {
    const pathKey = getPathKey(path);
    if (!window?.newrelic) return;
    let statusCode;
    if (error?.response) {
        // Server responded with a status code
        statusCode = error.response.status;
    } else if (error?.request) {
        // No response received — could be network or CORS
        statusCode = error?.message || 'N/E';
    } else {
        // Something else triggered the error
        statusCode = error?.message || 'U/E';
    }
    if (retryCount) {
        statusCode += `:${retryCount}`;
    }
    const existing = logCache[pathKey];
    if (existing) {
        statusCode = existing + `;${statusCode}`;
    }
    logCache[pathKey] = statusCode;
    window.newrelic?.setCustomAttribute(pathKey, statusCode);
    return;
}
export function logResponseSuccess(response, path) {
    const pathKey = getPathKey(path);
    if (!window?.newrelic) return;
    let statusCode = response?.status;
    const existing = logCache[pathKey];
    if (existing) {
        statusCode = existing + `;${statusCode}`;
    }
    logCache[pathKey] = statusCode;
    window.newrelic?.setCustomAttribute(pathKey, statusCode);
    return;
}
